/**
 * @type {String} Default locale for translations
 */
exports.DEFAULT_LOCALE = 'en-US';
